import { render, staticRenderFns } from "./SortByName.vue?vue&type=template&id=17c68040&scoped=true"
import script from "./SortByName.vue?vue&type=script&lang=js"
export * from "./SortByName.vue?vue&type=script&lang=js"
import style0 from "./SortByName.vue?vue&type=style&index=0&id=17c68040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c68040",
  null
  
)

export default component.exports